<template>
  <div
    class="searchCondition"
    :class="{
      '-narrow': hasHeader === false,
      '-isSidebar': isSidebar === true,
      '-keywordOnly': keywordOnly === false
    }"
  >
    <div class="searchCondition_header" v-if="hasHeader">
      <p class="searchCondition_ttl">現在の検索条件</p>
      <button
        @click="$store.dispatch('showSearchModal')"
        type="button"
        class="searchCondition_button"
      >
        条件の変更
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="13.993"
          viewBox="0 0 8 13.993"
        >
          <path
            d="M5.588,7,.294,12.289A1,1,0,1,0,1.71,13.7l6-5.995a1,1,0,0,0,.029-1.379L1.714.292A1,1,0,1,0,.3,1.7Z"
            transform="translate(0 0)"
            fill="#58d1ca"
          />
        </svg>
      </button>
    </div>

    <div v-if="currentConditions.length > 0">
      <div class="searchCondition_list">
        <ul>
          <li v-for="(tag, i) in currentConditionsTag" :key="i">{{ tag }}</li>
        </ul>
      </div>

      <div class="searchCondition_sidebar" v-if="isSidebar">
        <div
          class="searchCondition_sidebar_item"
          v-for="(condition, j) in currentConditions"
          :key="j"
        >
          <div class="searchCondition_sidebar_item_head">
            {{ condition.name }}
          </div>
          <div class="searchCondition_sidebar_item_data">
            {{ condition.value }}
          </div>
        </div>
      </div>
    </div>
    <p class="searchCondition_empty" v-if="currentConditions.length === 0">
      現在選択している条件はありません。
    </p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { useSearchCondition } from '@/utils/useSearchCondition'

export default defineComponent({
  name: 'SearchCondition',

  props: {
    querys: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String as PropType<'hospital' | 'latter'>,
      default: 'hospital'
    },
    hasHeader: {
      type: Boolean,
      default: true
    },
    keywordOnly: {
      type: Boolean,
      default: false
    },
    isSidebar: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const {
      getSearchConditionFromQuery,
      getSearchConditionTag
    } = useSearchCondition()

    const currentConditions = computed(() =>
      getSearchConditionFromQuery(props.querys, props.type)
    )

    const currentConditionsTag = computed(() =>
      getSearchConditionTag(currentConditions.value)
    )

    return {
      currentConditions,
      currentConditionsTag
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.searchCondition {
  background-color: #f5f5f5;
  width: 100%;
  padding: 20px 0 24px;
  transition: padding 0.2s;

  @include mixins.media() {
    &.-isSidebar {
      // width: 30.8%;
      width: 100%;
      position: relative;
      padding: 24px 20px 64px;
      &.-negativeMargin {
        margin-right: 0;
        margin-left: 0;
      }
      .searchCondition_header {
        padding: 0;
        margin-bottom: 24px;
      }
      .searchCondition_list {
        display: none;
      }
      .searchCondition_sidebar {
        margin-bottom: 24px;
        &_item {
          border-bottom: 1px solid var.$color-border-gray;
          padding-bottom: 7px;
          margin-bottom: 8px;
          &_head {
            color: var.$color-gray;
          }
        }
      }
      .searchCondition_button {
        position: absolute;
        bottom: 24px;
        left: 50%;
        transform: translateX(-50%);
        height: 40px;
        width: 150px;
        border-radius: 20px;
        background-color: #e5f7f6;
        color: var.$color-main;
        font-weight: bold;
        justify-content: center;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

        &:hover {
          opacity: 1;
          background-color: #b3eeea;
        }

        svg {
          display: none;
        }
      }
    }
  }

  &.-narrow {
    padding: 6px 0 16px;
  }

  &.-keywordOnly {
    padding: 6px 0 16px;

    .searchCondition_header {
      height: 0;
    }
  }

  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    overflow: hidden;
    height: 28px;
    transition: height 0.2s;
  }

  &_ttl {
    font-weight: 700;
  }

  &_button {
    color: var.$color-main;
    display: flex;
    align-items: center;

    svg {
      margin-left: 8px;
      width: 6px;
      height: auto;
    }
  }

  &_list {
    margin-top: 10px;
    overflow-x: auto;
    width: 100%;
    display: flex;

    > ul {
      display: flex;

      > li {
        font-size: 1.3rem;
        font-weight: 500;
        background-color: #fff;
        color: #666;
        padding: 8px 10px;
        line-height: 1;
        white-space: nowrap;
        border-radius: 2px;
        border: 1px solid #e4e4e4;

        &:not(:first-child) {
          margin-left: 5px;
        }

        &:first-child {
          margin-left: 16px;
        }

        &:last-child {
          margin-right: 16px;
        }
      }
    }
  }

  &_empty {
    margin-top: 12px;
    margin-left: 16px;

    @include mixins.media() {
      margin-top: -10px;
      margin-left: 0;
      margin-bottom: 40px;
    }
  }

  &_sidebar {
    display: none;
    @include mixins.media() {
      display: block;
    }
  }
}
</style>
